exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".main{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3b995c43!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main.vue
// module id = 582
// module chunks = 2